export default {
      id: "circle__satellit-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.svg#circle__satellit",
      toString: function () {
        return this.url;
      }
    }